import React, { useEffect, useRef } from "react";

import Button from "../components/Button";

import { IoMdClose } from "react-icons/io";

const Modal = ({ project, onClose }) => {
  const buttonConfig = project.deprecated
    ? {
        text: "Website offline",
        link: null,
        disabled: true,
        newTab: false,
        id: 1,
      }
    : {
        text: project.type === "repo" ? "View Repo" : "View Site",
        link: project.link,
        newTab: true,
        id: 1,
      };

  const modalRef = useRef(null);

  const handleClose = () => {
    onClose();
  };

  const handleOverlayClick = (event) => {
    if (modalRef.current === event.target) {
      onClose();
    }
  };

  useEffect(() => {
    if (modalRef.current) {
      document.body.classList.add("modal-open");
    }

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <div
      className='fixed inset-0 z-50 flex items-center justify-center'
      ref={modalRef}
      onClick={handleOverlayClick}
    >
      <div className='fixed inset-0 backdrop-blur-md backdrop-filter bg-primary bg-opacity-30'></div>
      <div className='bg-white rounded-lg p-6 z-10 relative max-w-xl w-full md:w-[80%]'>
        <button
          className='absolute top-0 right-0 m-4 p-2'
          onClick={handleClose}
        >
          <IoMdClose size={30} />
        </button>
        <div className='flex flex-col justify-center items-center gap-6'>
          <h2 className='text-3xl font-semibold'>{project.title}</h2>
          <div className='max-h-[50vh] overflow-auto'>
            <p
              className='text-lg text-secondary'
              dangerouslySetInnerHTML={{ __html: project.description }}
            />
            <div className='flex text-lg gap-6 pt-2'>
              <p>Stack:</p>
              <p>{project.stack}</p>
            </div>
          </div>
          <Button buttonConfig={buttonConfig} />
        </div>
      </div>
    </div>
  );
};

export default Modal;
